import { makeAutoObservable, runInAction } from 'mobx'

import { serverMessage } from '@/Ship/Helpers/serverError'

import { LoadLetterTemplateVariablesTask } from '../Tasks/LoadLetterTemplateVariablesTask'

import type { LetterTemplateVariable } from '../Contracts/LetterTemplate'

/**
 * Каталоги змінних шаблону листа за провайдером (`SPEC-013` §5.7, §9.1).
 *
 * Каталог провайдера не змінюється за життя сторінки, тож завантажений раз
 * він лишається в сторі: перемикання провайдера туди й назад не шле запит
 * удруге. Відповідь на застарілий провайдер (людина встигла обрати інший)
 * просто лягає у свій ключ і нічого не перетирає.
 */
export class LetterTemplateVariablesStore {
    byProvider: Record<string, LetterTemplateVariable[]> = {}
    loading: Record<string, boolean> = {}
    errors: Record<string, string> = {}

    constructor() {
        makeAutoObservable(this)
    }

    variables(provider: string): LetterTemplateVariable[] | null {
        return this.byProvider[provider] ?? null
    }

    isLoading(provider: string): boolean {
        return this.loading[provider] === true
    }

    error(provider: string): string | null {
        return this.errors[provider] ?? null
    }

    async load(provider: string): Promise<void> {
        if (provider === '' || this.byProvider[provider] !== undefined || this.loading[provider] === true) return

        this.loading[provider] = true
        delete this.errors[provider]

        try {
            const items = await LoadLetterTemplateVariablesTask(provider)

            runInAction(() => {
                this.byProvider[provider] = items
            })
        } catch (error) {
            runInAction(() => {
                this.errors[provider] = serverMessage(error, 'Не вдалося завантажити змінні')
            })
        } finally {
            runInAction(() => {
                delete this.loading[provider]
            })
        }
    }
}

/** Один стор на застосунок: каталоги однакові для всіх форм шаблонів. */
export const letterTemplateVariablesStore = new LetterTemplateVariablesStore()
